module.exports = __webpack_public_path__ + "static/media/typing-big.7acdec87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/photos/typing-big.jpg
// module id = 139
// module chunks = 0